<template>
  <Drawer
    v-bind="props"
    :visible="modelValue"
    @update:visible="updateValue"
  >
    <template
      v-for="(slotContent, slotName) in slots"
      :key="slotName"
      #[slotName]
    >
      <component :is="slotContent" />
    </template>
  </Drawer>
</template>
<script setup lang="ts">
/** Sidebar with overlay
 * It wrapper for primevue component.
 * Check all API for component https://primevue.org/drawer/
 */
import Drawer from "primevue/drawer"

interface Props {
  modelValue: boolean
}

const emit = defineEmits(["update:modelValue"])

const props = withDefaults(defineProps<Props>(), {
  modelValue: false,
})

const slots = defineSlots()
const updateValue = (value: boolean) => {
  emit("update:modelValue", value)
}
</script>
